import { makeStyles, Theme } from "@material-ui/core";

export const useStyles = makeStyles<Theme>((theme) => ({
    cardHistorico: {
        padding: theme.spacing(2, 1)
    },
    centeredValue: {
        display: 'block',
        textAlign: 'center'
    },
    mobileLabel: {
        [theme.breakpoints.up('md')]: {
            display: 'none'
        }
    },
    textBreak: {
        wordBreak: 'break-word',
    }
}))